exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-field-g[data-v-826ae00c] {\n    border-radius: 3px;\n    border-style: solid;\n    border-width: 2px;\n    border-color: #757575;\n    width: 65px;\n}\n.select-criterion[data-v-826ae00c] {\n    width: 100px;\n}\n.stepper-scrollable-content[data-v-826ae00c] {\n    overflow: auto;\n    max-height: calc(100% - 71px);\n}\n\n", ""]);

// exports
